import React from 'react';
import { CalendarEvent } from './useEventsAdminList';
import { Schema } from '../../../toolympus/hooks/useSchema';
import { NewItemProps } from '../../../toolympus/api/useNewItem';
import { SimpleDialog, FormGrid } from '../../../toolympus/components/primitives';
import { FormControlsForFields } from '../../../toolympus/components/schemed';
import { DateAndTimeEdit } from '../../../toolympus/components/schemed/TimeEdit';

interface Props extends NewItemProps<Partial<CalendarEvent>, CalendarEvent> {
  schema: Schema;
}

export const CreateEventDialog = (props: Props) => {
  const { isEditing, cancel, errors, item, update, save, schema } = props;
  return (
    <SimpleDialog
      isOpen={isEditing}
      close={cancel}
      dialogTitle="New event"
      submitOnModEnter
      noFullscreen
      save={() => save()}>
      {item && <FormGrid columns="1fr">
        <FormControlsForFields
          fields={[
            ["title"],
          ]}
          data={item}
          onChange={(o,c) => update(c)}
          errors={errors}
          schema={schema}
          />

        <FormGrid columns="1fr 1fr 1fr" forceEvenColumns noMargin>
          <DateAndTimeEdit
            field="start_datetime"
            row={item}
            onChange={(o,c) => update(c)}
            schema={schema.start_datetime}
            dateSchema={{ label: "Date"}}
            errors={errors}
            />
          <DateAndTimeEdit
            field="end_datetime"
            row={item}
            onChange={(o,c) => update(c)}
            schema={schema.end_datetime}
            noDate
            errors={errors}
            />
        </FormGrid>
      </FormGrid>}
    </SimpleDialog>
  );
}

